<template>
    <div v-if="chartData" id="events-categoryaxis"></div>
</template>

<script>

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themes_material from '@amcharts/amcharts4/themes/material.js'
    import am4themes_animated from '@amcharts/amcharts4/themes/animated'

    am4core.useTheme(am4themes_animated)
    am4core.useTheme(am4themes_material)
    export default {
        name: 'curved-columns',
        props: {
            chartData: Array,
        },

		data() {
			return {
                chart: null,
			}
        },
        
        mounted() {
            this.initialize()
        },
        
        methods: {

            initialize() {
                if (this.chart) {
                    this.chart.dispose();
                }
                this.chart = am4core.create('events-categoryaxis', am4charts.XYChart)
                this.chart.hiddenState.properties.opacity = 0 // this makes initial fade in effect

                this.chart.data = this.chartData

                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                categoryAxis.renderer.grid.template.location = 0
                categoryAxis.dataFields.category = 'month'
                categoryAxis.renderer.minGridDistance = 40

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())

                let series = this.chart.series.push(new am4charts.CurvedColumnSeries())
                series.dataFields.categoryX = 'month'
                series.dataFields.valueY = 'quantity'
                series.tooltipText = '{valueY.value}'
                series.columns.template.strokeOpacity = 0

                series.columns.template.fillOpacity = 0.75

                let hoverState = series.columns.template.states.create('hover')
                hoverState.properties.fillOpacity = 1
                hoverState.properties.tension = 0.4

                this.chart.cursor = new am4charts.XYCursor()

                // Add distinctive colors for each column using adapter
                series.columns.template.adapter.add('fill', (fill, target) => {
                    return this.chart.colors.getIndex(target.dataItem.index)
                })

                this.chart.scrollbarX = new am4core.Scrollbar()
            }
        },

        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        },

        watch: {
            chartData: {
                handler() {
                    this.initialize()
                },
                deep: true
            },
        }
    }
</script>

<style>

</style>
